var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Autocomplete',{attrs:{"items":_vm.filteredCities,"get-label":_vm.getLabel,"component-item":_vm.template,"auto-select-one-item":false,"min-len":2,"input-attrs":_vm.options,"wait":0},on:{"update-items":_vm.update,"item-selected":_vm.itemSelected},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c87d0186","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autosuggest/Autosuggest.vue
// module id = null
// module chunks = 